import { render } from "./KpiSectionSkeleton.vue?vue&type=template&id=4c704218&scoped=true"
import script from "./KpiSectionSkeleton.vue?vue&type=script&lang=js"
export * from "./KpiSectionSkeleton.vue?vue&type=script&lang=js"

import "./KpiSectionSkeleton.vue?vue&type=style&index=0&id=4c704218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c704218"]])

export default __exports__